/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Descriptionpasswordless1Inputs */

const he_auth_signup_descriptionpasswordless1 = /** @type {(inputs: Auth_Signup_Descriptionpasswordless1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו חשבון עם אימייל + קוד חד-פעמי (ללא סיסמה).`)
};

const en_auth_signup_descriptionpasswordless1 = /** @type {(inputs: Auth_Signup_Descriptionpasswordless1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your account with email + one-time code (passwordless).`)
};

/**
* | output |
* | --- |
* | "Create your account with email + one-time code (passwordless)." |
*
* @param {Auth_Signup_Descriptionpasswordless1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_signup_descriptionpasswordless1 = /** @type {((inputs?: Auth_Signup_Descriptionpasswordless1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Descriptionpasswordless1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_descriptionpasswordless1(inputs)
	return en_auth_signup_descriptionpasswordless1(inputs)
});
export { auth_signup_descriptionpasswordless1 as "auth_signup_descriptionPasswordless" }